import styled from 'styled-components';
import { useState } from 'react';
import { screenMd } from 'constants/styles/breakpoints';
import { BodyTitle } from '../RemoveUsers/styles';
import { colors } from 'constants/styles/colors';
import { CUSTOM_MESSAGE_LABEL, CUSTOM_MESSAGE_TITLE, MESSAGE_MAX_LENGTH } from 'constants/invites';

const Container = styled.div`
  position: relative;
  padding: 10px;
  ${screenMd} {
    padding: 0px;
  }
`;

const Title = styled(BodyTitle)`
  color: ${colors.dataVisualization.black.dark};
  font-weight: 900;
  margin: 0 0 10px;
`;

const Textarea = styled.textarea`
  resize: none;
  font-size: 12px;
  line-height: 14px;
  /* Room at the bottom for the counter that sits inside the box. */
  padding: 15px 10px 28px;
  margin: 0;
  background: ${colors.palette.Business_LightThemeGreyLighter};
  width: 100%;
  border: none;
  border-radius: 10px;
  min-height: 100px;
  font-family: var(--font-family-base);
  color: ${colors.buttons.blackGray};
  &:focus {
    outline: none;
  }
`;

const CharCounter = styled.div`
  font-size: 10px;
  line-height: 12px;
  font-weight: 450;
  color: ${colors.fonts.lightGray};
  position: absolute;
  bottom: 10px;
  right: 10px;
`;

interface AddMessage {
  onMessageUpdate(message: string): void;
  /** Initial text; the caller keeps the message across Back. */
  defaultValue?: string;
}

const COUNTER_ID = 'invite-message-counter';

const AddMessageComponent: React.FC<AddMessage> = ({ onMessageUpdate, defaultValue = '' }) => {
  const [counter, setCounter] = useState(defaultValue.length);
  const handleMessageChange = (e) => {
    onMessageUpdate(e.target.value);
    setCounter(e.target.value.length);
  };

  return (
    <Container>
      <Title>{CUSTOM_MESSAGE_TITLE}</Title>
      <Textarea
        aria-label={CUSTOM_MESSAGE_LABEL}
        defaultValue={defaultValue}
        maxLength={MESSAGE_MAX_LENGTH}
        aria-describedby={COUNTER_ID}
        onChange={handleMessageChange}
      />
      <CharCounter id={COUNTER_ID}>
        {counter}/{MESSAGE_MAX_LENGTH}
      </CharCounter>
    </Container>
  );
};

export default AddMessageComponent;
